import * as React from 'react';
import { Button } from '@cian/ui-kit/prev';
import * as styles from './DealRentDescription.css';
import { trackSafeRentDescriptionShow, trackSafeRentDescriptionClick } from './tracking';

export interface ISafeRentDescriptionProps {
  id: number;
  openModal(): void;
}

export const DealRentDescription = ({ id, openModal }: ISafeRentDescriptionProps) => {
  React.useEffect(() => {
    trackSafeRentDescriptionShow(id);
  }, [id]);

  return (
    <div id="deal-rent" className={styles['block']}>
      <div className={styles['title']}>
        Чтобы договориться о просмотре с собственником напрямую,
        <br />
        заполните анкету и отправьте заявку
      </div>

      <div className={styles['description']}>
        👋 Чем более полную информацию вы укажите, тем выше шанс снять квартиру!
      </div>

      <Button
        custom={{ type: 'primary', mediaType: 'mobile' }}
        onClick={() => {
          trackSafeRentDescriptionClick(id);
          openModal();
        }}
      >
        <span className={styles['button-text']}>Назначить просмотр</span>
      </Button>
    </div>
  );
};
